// THIS FILE IS NOT BEING USED CURRENTLY. NOT DELETING IT ENTIRELY, IN CASE WE WANT TO REVISIT
 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseSheetMultipleAdd',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('CruiseSheets/multipleAdd', function onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load()
	{
		var i             = 4,
		    $cs_dd        = $("#cruisesheetmultipleadd-num_cruise_sheets"),
		    panel_css     = 'multiple-add-cs',
		    container_css = 'multiple-add-cs-container';

		// Tiny MCE fields
		// Adzuki.Editor('#cruisesheetmultipleadd-comments');
		Adzuki.Editor('#cruisesheetmultipleadd-message');

		// turn MCE editor on for each cruise sheet comments
		for (i; i >= 1; i--) {
			Adzuki.Editor('#cruisesheetmultipleadd-sailings-' + i + '-comments');
		}

		$cs_dd.on("change", function numChange() {
			var $self = $(this);
			toggleCruiseSheets($self);
			renumber();
		});

		/**
		 * Changing the number of cruise sheets via an element such as a drop-down menu
		 * @param  jQuery Object $el The element that dictates the number of cruise sheets
		 */
		function toggleCruiseSheets($el) {
			var show_count = $el.val(),
			    $elements  = $('.' + panel_css);

			toggleContainer(show_count);

			$elements.each(function iti( index, value ) {
				var $element = $(this),
				    count    = index + 1,
				    enable   = true;

				if (count <= show_count) {
					$element.removeClass('hidden');
				} else {
					$element.addClass('hidden');
					enable = false;
				}

				togglePanelFields($element, enable);
			});
		}

		/**
		 * Enable or disable all of the fields for a cruise sheet panel.  We want to disable hidden ones so they don't post and keeps things cleaner
		 * @param  jQuery object  $panel The panel that contains the form fields for a particular cruise sheet details
		 * @param  boolean        enable True to enable.  False to disable
		 */
		function togglePanelFields($panel, enable) {
			var $inputs = $panel.find('select, textarea');
			$inputs.each(function iti( index, value ) {
				var $el = $(this);
				if (enable) {
					$el.prop('disabled', false);
				} else {
					$el.prop('disabled', true);
				}
			});
		}

		/**
		 * Toggle the container around the cruise sheet details, the "bundle" checkbox and the submit button. Only should be visible if at least 1 cruise sheet
		 * @param  int  count  number of cruise sheets that should be visible
		 */
		function toggleContainer(count) {
			var countInt = parseInt(count);

			// at least 1 cruise sheet
			if (countInt > 0) {
				$('.' + container_css).removeClass('hidden');
			} else {
				$('.' + container_css).addClass('hidden');
			}
		}

		/**
		 * Change the number in the "# of Cruise Sheets" drop-down. For example after a user clicks the "X" for a specific one.
		 */
		function reduceCruiseSheet() {
			var current_val = $cs_dd.val(),
			    new_val     = current_val - 1;

			$cs_dd.val(new_val);
			toggleContainer(new_val);
		}

		/**
		 * Sometimes we need to re-number the panel based on the user's actions for display purposes.
		 */
		function renumber() {
			var $elements     = $('.' + panel_css),
			    visible_count = 0;

			$elements.each(function iti( index, value ) {
				var $element  = $(this),
				    $count_el = $element.find('.count');

				if (!$element.hasClass('hidden')) {
					visible_count++;
					$count_el.html(visible_count);
				}
			});
		}


		/**
		 * Removing a single cruise sheet from the form by clicking on the "X"
		 */
		$(".multiple-remove-sheet").on("click", function remove(e) {
			var $self  = $(this),
			    $panel = getPanelByChild($self);

			e.preventDefault();
			reduceCruiseSheet($cs_dd);
			$panel.addClass('hidden');
			togglePanelFields($panel, false);
			renumber();
		});

		$(".multiple-add-cs .sailing-selection-cruise-line").on("change", function cruiseLineChange(e) {
			var $self               = $(this),
			    $panel              = getPanelByChild($self),
			    $pricing_container  = findPricingContainerByPanel($panel),
			    $manual_container   = findManualPricingElement($pricing_container);

			$pricing_container.addClass('hidden');  // hide pricing fields until a sailing is selected
			resetPricingMethodByPanel($panel);
			$manual_container.html('');
		});

		/**
		 * When a ship is selected, we are going to populate the manual ship category pricing div via ajax.  The div will remain hidden until a sailing is selected
		 */
		$(".multiple-add-cs .sailing-selection-ships").on("change", function shipChange(e) {
			var $self               = $(this),
			    $panel              = getPanelByChild($self),
			    $pricing_container  = findPricingContainerByPanel($panel),
			    $category_container = findManualPricingElement($pricing_container),
			    panel_count         = $panel.find('.count').html(),
			    url                 = '/ShipCategories/ajaxManualRatesFields/' + $self.val() + '/' + parseInt(panel_count);

			Adzuki.Ajax.get(url).then(function success(response) {
				$pricing_container.addClass('hidden');  // hide pricing fields until a sailing is selected
				$category_container.html(response);     // fill in div with pricing fields
				resetPricingMethodByPanel($panel);      // reset to manual.  Don't know if eConnect will be available
			});
		});

		// when a sailing is selected
		$(".multiple-add-cs .sailing-selection-sailings").on("change", function sailingChange(e) {
			var $self               = $(this),
			    url                 = '/Itineraries/ajaxGetSabreCode/' + $self.val(),
			    $panel              = getPanelByChild($self),
			    $pricing_container  = findPricingContainerByPanel($panel),
			    $pricing_methods    = findPricingMethods($pricing_container),
			    $econnect_container = findEconnectlPricingElement($pricing_container),
			    $manual_pricing     = findManualPricingElement($pricing_container);

			$pricing_container.removeClass('hidden');

			Adzuki.Ajax.get(url).then(function success(response) {

				// we got a sabre_code returned, so we can show econnect option
				if ((typeof response) === 'string') {
					$pricing_methods.removeClass('hidden');
					// $econnect_container.removeClass('hidden');
					$econnect_container.html(response);
				} else {
					resetPricingMethod($pricing_methods, $manual_pricing, $econnect_container);
				}
			});
		});

		// when a pricing method is changed
		$(".multiple-add-cs .pricing-method").on("change", function sailingChange(e) {
			var $self             = $(this),
			    $panel            = getPanelByChild($self),
			    $manual_pricing   = findManualPricingElement($panel),
			    $econnect_pricing = findEconnectlPricingElement($panel);

			if ($self.val() === 'manual') {
				$manual_pricing.removeClass('hidden');
				$econnect_pricing.addClass('hidden');
			} else {
				$econnect_pricing.removeClass('hidden');
				$manual_pricing.addClass('hidden');
			}
		});

		function resetPricingMethodByPanel($panel)
		{
			var $pricing_container  = findPricingContainerByPanel($panel),
			    $pricing_methods    = findPricingMethods($pricing_container),
			    $manual_pricing     = findManualPricingElement($pricing_container),
			    $econnect_container = findEconnectlPricingElement($pricing_container);

			resetPricingMethod($pricing_methods, $manual_pricing, $econnect_container);
		}

		function resetPricingMethod($pricing_methods, $manual_pricing, $econnect_container)
		{
			var $pricing_method_dd  = $pricing_methods.find('.pricing-method');

			$pricing_methods.addClass('hidden');
			$pricing_method_dd.val('manual');
			$manual_pricing.removeClass('hidden');
			$econnect_container.addClass('hidden');
		}

		function getPanelByChild($el)
		{
			return $el.closest('.' + panel_css);
		}

		function findPricingContainerByPanel($panel)
		{
			return $panel.find('.multiple-cs-pricing');
		}

		function findManualPricingElement($parent_el)
		{
			return $parent_el.find('.manual_pricing');
		}

		function findEconnectlPricingElement($parent_el)
		{
			return $parent_el.find('.econnect_pricing');
		}

		function findPricingMethods($parent_el)
		{
			return $parent_el.find('.pricing-methods');
		}



		// if recipient removed, disable send button until form passes validation and is saved
		// $(".selected-recipients").on('click', '.remove', function remove() {
		// 	$('#send-cruise-sheet').prop('disabled', true);
		// });
	};

}(jQuery, window.Adzuki || {}));
